import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { UpdateEmailPayload } from 'Interfaces/Profile';
import { $actions } from 'Store';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction(async (payload: UpdateEmailPayload) =>
    $actions.user.updateEmail(dispatch, payload),
  );
};
